export type VoyagerLeadsState = {
  busy: boolean;
  attributes: VoyagerAttributes[];
  contacts: VoyagerContacts;
};

export type VoyagerAttributes = {
  attribute: string;
  items: string[];
};

export type VoyagerLeadRecordType = {
  id: string;
  firstName: string | null;
  jobTitle: string | null;
  professionalCity: string | null;
  professionalState: string | null;
  companyName: string | null;
  companyEmployeeCount: string | null;
  converted?: boolean;
};

export type VoyagerContacts = {
  total?: number;
  page?: number;
  perPage?: number;
  count?: number;
  records?: VoyagerLeadRecordType[];
};

export type VoyagerRemoteAttributeSearch = {
  attribute: VoyagerKeyType;
  items: string[];
};

export type VoyagerLocationsSearch = {
  attribute: VoyagerKeyType;
  value: string;
};

export type VoyagerCreateContactsResponse = {
  audienceId: number;
  userId: number;
  createdAt: string;
  status: string;
};

export type VoyagerQueryType = {
  field: VoyagerKeyType;
  values: string[];
  operator?: 'in' | 'not_in'; // 'in' is default, not need to specify it
};

export type VoyagerLeadsSearchQuery = {
  query: VoyagerQueryType[];
  page?: number;
  perPage?: number;
  limit?: number;
};

export type CreateVoyagerContactsSearchParams = {
  total?: number;
  page?: number;
  perPage?: number;
  query?: VoyagerQueryType;
  ids?: string[];
};

export type CreateVoyagerContactsParams = {
  facebookPageId: number;
  search: CreateVoyagerContactsSearchParams;
  audience?: {
    name: string;
  };
};

export const VOYAGER_KEYS = {
  jobTitle: 'JOB_TITLE',
  industry: 'PRIMARY_INDUSTRY',
  seniorityLevel: 'SENIORITY_LEVEL',
  revenue: 'COMPANY_REVENUE',
  state: 'PROFESSIONAL_STATE',
  city: 'PROFESSIONAL_CITY',
  zip: 'PROFESSIONAL_ZIP',
  department: 'DEPARTMENT',
  employees: 'COMPANY_EMPLOYEE_COUNT',
  domain: 'COMPANY_DOMAIN',
  companyName: 'COMPANY_NAME',
} as const;

export const VOYAGER_FRIENDLY_NAMES = {
  JOB_TITLE: 'Job Title',
  PRIMARY_INDUSTRY: 'Industry',
  SENIORITY_LEVEL: 'Seniority Level',
  COMPANY_REVENUE: 'Revenue',
  PROFESSIONAL_STATE: 'State',
  PROFESSIONAL_CITY: 'City',
  PROFESSIONAL_ZIP: 'ZIP',
  DEPARTMENT: 'Department',
  COMPANY_EMPLOYEE_COUNT: 'Employees',
  COMPANY_DOMAIN: 'Domain',
  COMPANY_NAME: 'Company Name',
};

type VoagerFilterTypeTuple = typeof VOYAGER_KEYS;
export type VoyagerKeyType = VoagerFilterTypeTuple[keyof VoagerFilterTypeTuple];
